// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"125":"3f62fe65","453":"d7446e4a","551":"66dca899","842":"c4b86bec"}[chunkId] + ".chunk.js";
};